/**
 * Généré — un import dynamique par icône (hors syncCriticalSvgIcons).
 * Regénérer : node scripts/generate-svg-icon-loadModule.mjs
 */
import type { ComponentType } from "react";

export async function loadSvgIconModule(
  componentName: string
): Promise<{ default: ComponentType<any> } | null> {
  switch (componentName) {
    case "AddressFamilyIcon":
      return import(/* webpackChunkName: "svg-icon-address-family" */ "./AddressFamilyIcon");
    case "AddressFriendsIcon":
      return import(/* webpackChunkName: "svg-icon-address-friends" */ "./AddressFriendsIcon");
    case "AddressHolidaysIcon":
      return import(/* webpackChunkName: "svg-icon-address-holidays" */ "./AddressHolidaysIcon");
    case "AddressHouseIcon":
      return import(/* webpackChunkName: "svg-icon-address-house" */ "./AddressHouseIcon");
    case "AddressWorkIcon":
      return import(/* webpackChunkName: "svg-icon-address-work" */ "./AddressWorkIcon");
    case "AnniversaireIcon":
      return import(/* webpackChunkName: "svg-icon-anniversaire" */ "./AnniversaireIcon");
    case "AppIcon":
      return import(/* webpackChunkName: "svg-icon-app" */ "./AppIcon");
    case "ArrowLongLeftIcon":
      return import(/* webpackChunkName: "svg-icon-arrow-long-left" */ "./ArrowLongLeftIcon");
    case "ArrowLongRightIcon":
      return import(/* webpackChunkName: "svg-icon-arrow-long-right" */ "./ArrowLongRightIcon");
    case "ArrowSmallLeftIcon":
      return import(/* webpackChunkName: "svg-icon-arrow-small-left" */ "./ArrowSmallLeftIcon");
    case "ArrowSmallRightIcon":
      return import(/* webpackChunkName: "svg-icon-arrow-small-right" */ "./ArrowSmallRightIcon");
    case "ArrowheadDownIcon":
      return import(/* webpackChunkName: "svg-icon-arrowhead-down" */ "./ArrowheadDownIcon");
    case "ArrowheadUpIcon":
      return import(/* webpackChunkName: "svg-icon-arrowhead-up" */ "./ArrowheadUpIcon");
    case "BirthdayIcon":
      return import(/* webpackChunkName: "svg-icon-birthday" */ "./BirthdayIcon");
    case "BulletInCircleIcon":
      return import(/* webpackChunkName: "svg-icon-bullet-in-circle" */ "./BulletInCircleIcon");
    case "CadeauIcon":
      return import(/* webpackChunkName: "svg-icon-cadeau" */ "./CadeauIcon");
    case "CagnotteBadgeIcon":
      return import(/* webpackChunkName: "svg-icon-cagnotte-badge" */ "./CagnotteBadgeIcon");
    case "CagnotteEuroIcon":
      return import(/* webpackChunkName: "svg-icon-cagnotte-euro" */ "./CagnotteEuroIcon");
    case "CalendarIcon":
      return import(/* webpackChunkName: "svg-icon-calendar" */ "./CalendarIcon");
    case "CaretDown16Icon":
      return import(/* webpackChunkName: "svg-icon-caret-down16" */ "./CaretDown16Icon");
    case "CaretDownBold16Icon":
      return import(/* webpackChunkName: "svg-icon-caret-down-bold16" */ "./CaretDownBold16Icon");
    case "CaretDownIcon":
      return import(/* webpackChunkName: "svg-icon-caret-down" */ "./CaretDownIcon");
    case "CaretRight16Icon":
      return import(/* webpackChunkName: "svg-icon-caret-right16" */ "./CaretRight16Icon");
    case "CaretRightBold16Icon":
      return import(/* webpackChunkName: "svg-icon-caret-right-bold16" */ "./CaretRightBold16Icon");
    case "CheckCircleFillIcon":
      return import(/* webpackChunkName: "svg-icon-check-circle-fill" */ "./CheckCircleFillIcon");
    case "CheckCircleIcon":
      return import(/* webpackChunkName: "svg-icon-check-circle" */ "./CheckCircleIcon");
    case "CheckMark16Icon":
      return import(/* webpackChunkName: "svg-icon-check-mark16" */ "./CheckMark16Icon");
    case "CheckMarkIcon":
      return import(/* webpackChunkName: "svg-icon-check-mark" */ "./CheckMarkIcon");
    case "CheckmarkFatIcon":
      return import(/* webpackChunkName: "svg-icon-checkmark-fat" */ "./CheckmarkFatIcon");
    case "CircleFillIcon":
      return import(/* webpackChunkName: "svg-icon-circle-fill" */ "./CircleFillIcon");
    case "ClickAndCollectIcon":
      return import(/* webpackChunkName: "svg-icon-click-and-collect" */ "./ClickAndCollectIcon");
    case "ClipboardIcon":
      return import(/* webpackChunkName: "svg-icon-clipboard" */ "./ClipboardIcon");
    case "ClockIcon":
      return import(/* webpackChunkName: "svg-icon-clock" */ "./ClockIcon");
    case "ConfettisBoldIcon":
      return import(/* webpackChunkName: "svg-icon-confettis-bold" */ "./ConfettisBoldIcon");
    case "CopyPasteIcon":
      return import(/* webpackChunkName: "svg-icon-copy-paste" */ "./CopyPasteIcon");
    case "CreditCardIcon":
      return import(/* webpackChunkName: "svg-icon-credit-card" */ "./CreditCardIcon");
    case "CrossCloseIcon":
      return import(/* webpackChunkName: "svg-icon-cross-close" */ "./CrossCloseIcon");
    case "CustomerServiceIcon":
      return import(/* webpackChunkName: "svg-icon-customer-service" */ "./CustomerServiceIcon");
    case "DeliveryIcon":
      return import(/* webpackChunkName: "svg-icon-delivery" */ "./DeliveryIcon");
    case "DeviceIcon":
      return import(/* webpackChunkName: "svg-icon-device" */ "./DeviceIcon");
    case "DownloadIcon":
      return import(/* webpackChunkName: "svg-icon-download" */ "./DownloadIcon");
    case "EditIcon":
      return import(/* webpackChunkName: "svg-icon-edit" */ "./EditIcon");
    case "EmptyCartIcon":
      return import(/* webpackChunkName: "svg-icon-empty-cart" */ "./EmptyCartIcon");
    case "EpicurienBasicIcon":
      return import(/* webpackChunkName: "svg-icon-epicurien-basic" */ "./EpicurienBasicIcon");
    case "EpicurienIcon":
      return import(/* webpackChunkName: "svg-icon-epicurien" */ "./EpicurienIcon");
    case "EtoilesIcon":
      return import(/* webpackChunkName: "svg-icon-etoiles" */ "./EtoilesIcon");
    case "ExclamationCircleFillIcon":
      return import(/* webpackChunkName: "svg-icon-exclamation-circle-fill" */ "./ExclamationCircleFillIcon");
    case "ExclamationCircleIcon":
      return import(/* webpackChunkName: "svg-icon-exclamation-circle" */ "./ExclamationCircleIcon");
    case "ExplorateurBasicIcon":
      return import(/* webpackChunkName: "svg-icon-explorateur-basic" */ "./ExplorateurBasicIcon");
    case "ExplorateurIcon":
      return import(/* webpackChunkName: "svg-icon-explorateur" */ "./ExplorateurIcon");
    case "EyeIcon":
      return import(/* webpackChunkName: "svg-icon-eye" */ "./EyeIcon");
    case "EyeOffIcon":
      return import(/* webpackChunkName: "svg-icon-eye-off" */ "./EyeOffIcon");
    case "FavorisFillIcon":
      return import(/* webpackChunkName: "svg-icon-favoris-fill" */ "./FavorisFillIcon");
    case "FavorisIcon":
      return import(/* webpackChunkName: "svg-icon-favoris" */ "./FavorisIcon");
    case "FidelityIcon":
      return import(/* webpackChunkName: "svg-icon-fidelity" */ "./FidelityIcon");
    case "FiltersIcon":
      return import(/* webpackChunkName: "svg-icon-filters" */ "./FiltersIcon");
    case "GeolocArrowIcon":
      return import(/* webpackChunkName: "svg-icon-geoloc-arrow" */ "./GeolocArrowIcon");
    case "GeolocIcon":
      return import(/* webpackChunkName: "svg-icon-geoloc" */ "./GeolocIcon");
    case "GiftBoldIcon":
      return import(/* webpackChunkName: "svg-icon-gift-bold" */ "./GiftBoldIcon");
    case "GiftIcon":
      return import(/* webpackChunkName: "svg-icon-gift" */ "./GiftIcon");
    case "GourmetBasicIcon":
      return import(/* webpackChunkName: "svg-icon-gourmet-basic" */ "./GourmetBasicIcon");
    case "GourmetIcon":
      return import(/* webpackChunkName: "svg-icon-gourmet" */ "./GourmetIcon");
    case "Home96Icon":
      return import(/* webpackChunkName: "svg-icon-home96" */ "./Home96Icon");
    case "HomeIcon":
      return import(/* webpackChunkName: "svg-icon-home" */ "./HomeIcon");
    case "InformationCircleFillIcon":
      return import(/* webpackChunkName: "svg-icon-information-circle-fill" */ "./InformationCircleFillIcon");
    case "InstagramIcon":
      return import(/* webpackChunkName: "svg-icon-instagram" */ "./InstagramIcon");
    case "ListIcon":
      return import(/* webpackChunkName: "svg-icon-list" */ "./ListIcon");
    case "LogoComeinIchiIcon":
      return import(/* webpackChunkName: "svg-icon-logo-comein-ichi" */ "./LogoComeinIchiIcon");
    case "LogoComeinNiIcon":
      return import(/* webpackChunkName: "svg-icon-logo-comein-ni" */ "./LogoComeinNiIcon");
    case "LogoComeinSanIcon":
      return import(/* webpackChunkName: "svg-icon-logo-comein-san" */ "./LogoComeinSanIcon");
    case "LogoFacebookIcon":
      return import(/* webpackChunkName: "svg-icon-logo-facebook" */ "./LogoFacebookIcon");
    case "LogoInstagramIcon":
      return import(/* webpackChunkName: "svg-icon-logo-instagram" */ "./LogoInstagramIcon");
    case "LogoLinkedinIcon":
      return import(/* webpackChunkName: "svg-icon-logo-linkedin" */ "./LogoLinkedinIcon");
    case "LogoMySimpleIcon":
      return import(/* webpackChunkName: "svg-icon-logo-my-simple" */ "./LogoMySimpleIcon");
    case "LogoMySushiShopIcon":
      return import(/* webpackChunkName: "svg-icon-logo-my-sushi-shop" */ "./LogoMySushiShopIcon");
    case "LogoPinterestIcon":
      return import(/* webpackChunkName: "svg-icon-logo-pinterest" */ "./LogoPinterestIcon");
    case "LogoSushiShopIcon":
      return import(/* webpackChunkName: "svg-icon-logo-sushi-shop" */ "./LogoSushiShopIcon");
    case "LogoTiktokIcon":
      return import(/* webpackChunkName: "svg-icon-logo-tiktok" */ "./LogoTiktokIcon");
    case "LogoTwitterIcon":
      return import(/* webpackChunkName: "svg-icon-logo-twitter" */ "./LogoTwitterIcon");
    case "LogoTwitterXIcon":
      return import(/* webpackChunkName: "svg-icon-logo-twitter-x" */ "./LogoTwitterXIcon");
    case "MenuListIcon":
      return import(/* webpackChunkName: "svg-icon-menu-list" */ "./MenuListIcon");
    case "MessageIcon":
      return import(/* webpackChunkName: "svg-icon-message" */ "./MessageIcon");
    case "MinusBold16Icon":
      return import(/* webpackChunkName: "svg-icon-minus-bold16" */ "./MinusBold16Icon");
    case "MinusIcon":
      return import(/* webpackChunkName: "svg-icon-minus" */ "./MinusIcon");
    case "PadlockBoldIcon":
      return import(/* webpackChunkName: "svg-icon-padlock-bold" */ "./PadlockBoldIcon");
    case "PadlockIcon":
      return import(/* webpackChunkName: "svg-icon-padlock" */ "./PadlockIcon");
    case "PhoneIcon":
      return import(/* webpackChunkName: "svg-icon-phone" */ "./PhoneIcon");
    case "PinIcon":
      return import(/* webpackChunkName: "svg-icon-pin" */ "./PinIcon");
    case "PinOutlineIcon":
      return import(/* webpackChunkName: "svg-icon-pin-outline" */ "./PinOutlineIcon");
    case "PlayIcon":
      return import(/* webpackChunkName: "svg-icon-play" */ "./PlayIcon");
    case "PlusBold16Icon":
      return import(/* webpackChunkName: "svg-icon-plus-bold16" */ "./PlusBold16Icon");
    case "PlusCircleIcon":
      return import(/* webpackChunkName: "svg-icon-plus-circle" */ "./PlusCircleIcon");
    case "PlusIcon":
      return import(/* webpackChunkName: "svg-icon-plus" */ "./PlusIcon");
    case "PressBookmarkIcon":
      return import(/* webpackChunkName: "svg-icon-press-bookmark" */ "./PressBookmarkIcon");
    case "ReorderIcon":
      return import(/* webpackChunkName: "svg-icon-reorder" */ "./ReorderIcon");
    case "SmallCrossCloseIcon":
      return import(/* webpackChunkName: "svg-icon-small-cross-close" */ "./SmallCrossCloseIcon");
    case "StarEpicurienIcon":
      return import(/* webpackChunkName: "svg-icon-star-epicurien" */ "./StarEpicurienIcon");
    case "StarExplorateurIcon":
      return import(/* webpackChunkName: "svg-icon-star-explorateur" */ "./StarExplorateurIcon");
    case "StarFillHalfIcon":
      return import(/* webpackChunkName: "svg-icon-star-fill-half" */ "./StarFillHalfIcon");
    case "StarFillIcon":
      return import(/* webpackChunkName: "svg-icon-star-fill" */ "./StarFillIcon");
    case "StarFillRoundedIcon":
      return import(/* webpackChunkName: "svg-icon-star-fill-rounded" */ "./StarFillRoundedIcon");
    case "StarGourmetIcon":
      return import(/* webpackChunkName: "svg-icon-star-gourmet" */ "./StarGourmetIcon");
    case "StarIcon":
      return import(/* webpackChunkName: "svg-icon-star" */ "./StarIcon");
    case "StoreIcon":
      return import(/* webpackChunkName: "svg-icon-store" */ "./StoreIcon");
    case "SwitchArrowIcon":
      return import(/* webpackChunkName: "svg-icon-switch-arrow" */ "./SwitchArrowIcon");
    case "TagIcon":
      return import(/* webpackChunkName: "svg-icon-tag" */ "./TagIcon");
    case "TrashIcon":
      return import(/* webpackChunkName: "svg-icon-trash" */ "./TrashIcon");
    case "WalletBoldIcon":
      return import(/* webpackChunkName: "svg-icon-wallet-bold" */ "./WalletBoldIcon");
    case "WalletIcon":
      return import(/* webpackChunkName: "svg-icon-wallet" */ "./WalletIcon");
    default:
      return null;
  }
}
